import { FileEdit, Maximize2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { useProjectForm } from '@/providers/ProjectFormProvider';

interface MinimizedFormIndicatorProps {
  onClick: () => void;
  className?: string;
}

export function MinimizedFormIndicator({ onClick, className }: MinimizedFormIndicatorProps) {
  const { formState } = useProjectForm();

  if (!formState?.isMinimized) return null;

  return (
    <div className={cn("border-t bg-card", className)}>
      <Button
        variant="ghost"
        className="w-full justify-start gap-3 h-auto py-3 px-4 hover:bg-accent"
        onClick={onClick}
      >
        <div className="flex items-center justify-center h-10 w-10 rounded-lg bg-primary/10 text-primary shrink-0">
          <FileEdit className="h-5 w-5" />
        </div>
        <div className="flex-1 text-left min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <span className="font-medium text-sm truncate">
              {formState.formData?.projectName || 'New Project'}
            </span>
            <Badge variant="secondary" className="shrink-0 text-xs">
              Draft
            </Badge>
          </div>
          <p className="text-xs text-muted-foreground">
            Click to continue editing
          </p>
        </div>
        <Maximize2 className="h-4 w-4 text-muted-foreground shrink-0" />
      </Button>
    </div>
  );
}
